import { createSlice } from '@reduxjs/toolkit'

export const appSlice = createSlice({
  name: 'app',
  initialState: {
    flow: null,
    timerSeconds: null,
    progressBar: [],
    search: {
      type: '',
      value: '',
    },
  },
  reducers: {
    setFlow: (state, action) => {
      state.flow = action.payload
    },
    setTimerSeconds: (state, action) => {
      state.timerSeconds = action.payload
    },
    setProgressBar: (state, action) => {
      state.progressBar = action.payload
    },
    setSearch: (state, action) => {
      state.search = action.payload
    },
  },
})

export const { setFlow, setTimerSeconds, setProgressBar, setSearch } = appSlice.actions

export const selectFlow = (state: any) => state.app.flow
export const selectTimerSeconds = (state: any) => state.app.timerSeconds
export const selectProgressBarPages = (state: any) => state.app.progressBar
export const selectSearch = (state: any) => state.app.search

export default appSlice.reducer
